import React from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { StepMetadata } from '../../../../pages/DataFeedWizard/types';

export const stepMetadata: StepMetadata = {
  title: 'Upload Your Files',
  subtitle:
    'Upload data feed files from Vault or Excel to begin the import process',
  icon: React.createElement(CloudUploadIcon),
  buttonText: 'Upload',
};
